export function checkCookie(name: string): boolean {
  const match = new RegExp('(^| )' + name + '=([^;]+)').exec(document.cookie);
  return match ? true : false;
}
